import QuickFilter from "../../shared/Filter/QuickFilter";

export const QuickPlannedFilter = () => {
  const options = [
    { label: "All", value: "All" },
    { label: "Planned", value: "Planned" },
    { label: "Unplanned", value: "Unplanned" },
  ];
  return (
    <QuickFilter
      filter={{
        label: "Is Planned",
        options,
        queryParam: "isPlannedFilter",
      }}
      options={options}
    />
  );
};
